
'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView} from 'react-native';
import DateUtils from '../../../../../common/DateUtils';
import styles from '../style';
import { observer, inject } from 'mobx-react';
import Constraints from '../../../constaints/index';


@inject(stores => {
    const {searchDataStore} = stores,
        {flightType, customDays, selectCustomDate, customize,userSelectStr, handleCalendarStatus, initCalendar} = searchDataStore;

    return {
        userSelectStr,
        flightType,
        customDays,
        customize,
        selectCustomDate,
        handleCalendarStatus,
        initCalendar
    };
})

@observer
class Custom extends Component {
    constructor(props) {
        super(props);
    }

    selectDate = (data) => {
        if (!data) {
            return;
        }
        let dateArr = data.map((data) => {
            return data.value
        });
        this.props.selectCustomDate(dateArr);
        this.props.handleCalendarStatus(false)
    };

    openCalendar = () => {
        let {customDays, flightType} = this.props || {};
        let {startDate, endDate} = customDays || {};

        let goDate = startDate || DateUtils.getDateFormat();
        let backDate = endDate || DateUtils.addGoDate(goDate, 2);

        let tips = `去返程日期跨度必须在${Constraints.calendarLimit.min}-${Constraints.calendarLimit.max}天内`;
        let data = {
            minDate: DateUtils.addGoDate(new Date(), 0),
            maxDate: DateUtils.addGoDate(new Date(), 365),
            selectedDate: [goDate, backDate],
            canSelectSameDay: flightType === Constraints.flightType.oneway,
            selectedPayLoad: [{
                header: {
                    text: '最早出发',
                }
            }, {
                header: {
                    text: flightType === Constraints.flightType.oneway ? '最晚出发' : '最晚返回'
                }
            }],
            limitInfo: flightType === Constraints.flightType.oneway ? {}: {
                min: {
                    day: Constraints.calendarLimit.min,
                    message: tips
                },
                max: {
                    day: Constraints.calendarLimit.max,
                    message: tips
                }

            },
            getMergeDesc:() => {
                return '出行日期'
            },
            buttons:[
                {
                    type: 'default',
                    text: '确定',
                    onClick: this.selectDate
                }
            ]
        };

        this.props.initCalendar(data);
       this.props.handleCalendarStatus(true)
    };


    render() {
        let {customize, userSelectStr} = this.props || {};

        let showDates = customize ? userSelectStr + ' 出发' : '去选择';
        return (
            <View style={styles.customFilterBlock}>
                <Text style={styles.customTitle}>自定义时间</Text>
                <TouchableOpacity style={styles.selectField} onPress={this.openCalendar}>
                    <Text style={[styles.selectText, customize ? styles.selectActiveText: {}]}>{showDates}</Text>
                </TouchableOpacity>
            </View>
        )
    }
}

export default Custom;
